import { Row } from "@tanstack/react-table";

import { OrganizationNode } from "../types/commonTypes";

export const getTopLevelParentIndex = (row: Row<OrganizationNode>) => {
  let currentRow = row;
  while (currentRow.depth > 0) {
    currentRow = currentRow.getParentRow() as Row<OrganizationNode>;
  }
  return currentRow.index;
};
